var exports = {
  "_": "xaf9ae18d--deb506--close-button",
};

module.exports = exports;
